import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { filterByLabelEmailPhone, userListToLabelEmailPhoneValue } from "../../../../../Apis/functions";
import { CustomAddChip } from "../../../../../components/CustomAddChip";
import CustomModal from "../../../../../components/Modal/CustomModal";
import {PersonChipBlack} from "../../../../../components/buttons/IconButtons";

/**
 * @Author      Jhovanny Fragoso Marquez
 * @JobTitle    Frontend Developer
 * @Email       jfragoso@ibl.mx
 *
 * Modal component for assigning a host.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {boolean} props.show - Controls the visibility of the modal.
 * @param {Function} [props.onHide=() => {}] - Callback function triggered when the modal is closed.
 * @param {Function} [props.onConfirm=() => {}] - Callback function triggered when confirming the host assignment.
 * @param {Object|null} props.selectedHost - Currently selected host object.
 * @param {Function} props.setSelectedHost - Function to update the selected host.
 * @param {boolean} props.cleanChipSearchHost - Flag to reset the chip search input.
 * @param {Function} props.setCleanChipSearchHost - Function to update the `cleanChipSearchHost` state.
 * @param {boolean} props.emptyFields - Indicates whether required fields are empty.
 * @returns {JSX.Element} The rendered modal component.
 */


const AssingHostModal = ({
    show,
    onHide = () => { },
    onConfirm = () => { },
    selectedHost,
    setSelectedHost,
    cleanChipSearchHost,
    setCleanChipSearchHost,
    emptyFields,
}) => {

    const { t } = useTranslation()
    const { allEmployeesList } = useSelector((state) => state?.EmployeeRolesSlice);


    return (
        <div>
            <CustomModal
                show={show}
                title="assign_host"
                onHide={() => onHide()}
                onConfirm={() => onConfirm()}
                size="md"
                classNameBody="pt-2"
            >
                <CustomAddChip
                    autocompleteId={'slt_cvif_host'}
                    buttonId={'btn_ahm_host'}
                    label={t("employee")}
                    required={true}
                    data={userListToLabelEmailPhoneValue(allEmployeesList, 'userId', true, PersonChipBlack)}
                    placeholder={t("placeholder_host")}
                    selectedList={selectedHost}
                    setSelectedList={setSelectedHost}
                    cleanChipSearch={cleanChipSearchHost}
                    setCleanChipSearch={setCleanChipSearchHost}
                    noDisabledChip={true}
                    showRenderOption={true}
                    filterOptions={filterByLabelEmailPhone}
                    emptyFields={emptyFields}
                    maxLength={1}
                    hideButton
                    reset={false}
                    chipIcon={PersonChipBlack}
                />
            </CustomModal>
        </div >
    )
}

export default AssingHostModal
